// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__19Cil","fileEntry":"styles_fileEntry__Df5ko","downloadCircleWrapper":"styles_downloadCircleWrapper__2Tu-D"};